import { createSlice } from "@reduxjs/toolkit";
import * as actions from "../action/global";
import * as types from "../../types/global";
import Toast from "../../helpers/Toast";

type InitialState = {
  statesLists: types.statesListResponse[];
  walletTypeList: types.walletTypeListResponse[];
  bankList: types.bankListResponse[];
  settingList: types.settingResponse;
  branchList: types.getBranchListResponse[];
  bankAccount: types.getBankAccountResponse;
};

const initialState: InitialState = {
  statesLists: [],
  walletTypeList: [],
  bankList: [],
  settingList: {} as types.settingResponse,
  branchList: [],
  bankAccount: {} as types.getBankAccountResponse,
};

const globalSlices = createSlice({
  name: "global",
  initialState: initialState,
  reducers: {
    resetGlobal: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(actions.getStatesList.fulfilled, (state, action) => {
        state.statesLists = action.payload;
      })
      .addCase(actions.getStatesList.rejected, (state, action) => {
        state.statesLists = [];
        Toast.fire({
          icon: "error",
          title: "Fail to Get States List",
        });
      })
      .addCase(actions.getWalletTypeList.fulfilled, (state, action) => {
        state.walletTypeList = action.payload;
      })
      .addCase(actions.getWalletTypeList.rejected, (state, action) => {
        state.walletTypeList = [];
        Toast.fire({
          icon: "error",
          title: "Fail to Get Wallet Type List",
        });
      })

      .addCase(actions.getBankList.fulfilled, (state, action) => {
        state.bankList = action.payload;
      })
      .addCase(actions.getBankList.rejected, (state, action) => {
        state.bankList = [];
        Toast.fire({
          icon: "error",
          title: "Fail to Get Bank List",
        });
      })

      .addCase(actions.getSettingList.fulfilled, (state, action) => {
        state.settingList = action.payload;
      })
      .addCase(actions.getSettingList.rejected, (state, action) => {
        state.settingList = {} as types.settingResponse;
        Toast.fire({
          icon: "error",
          title: "Fail to get setting list",
        });
      })

      .addCase(actions.encryptPassword.fulfilled, (state, action) => {})
      .addCase(actions.encryptPassword.rejected, (state, action) => {
        Toast.fire({
          icon: "error",
          title: "Fail to Encrypt Password",
        });
      })

      .addCase(actions.getBranchList.fulfilled, (state, action) => {
        state.branchList = action.payload;
      })
      .addCase(actions.getBranchList.rejected, (state, action) => {
        state.branchList = [];
        Toast.fire({
          icon: "error",
          title: "Fail to get branch list",
        });
      })

      .addCase(actions.uploadFile.fulfilled, (state, action) => {})
      .addCase(actions.uploadFile.rejected, (state, action) => {
        state.branchList = [];
        Toast.fire({
          icon: "error",
          title: "Fail to upload file",
        });
      })
      .addCase(actions.getBankAccount.fulfilled, (state, action) => {
        state.bankAccount = action.payload;
      })
      .addCase(actions.getBankAccount.rejected, (state, action) => {
        state.bankList = [];
        Toast.fire({
          icon: "error",
          title: "Fail to get bank account",
        });
      });
  },
});

export const {} = globalSlices.actions;
export default globalSlices.reducer;
